// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Gru6","title":"Info_title__33_tw","selects":"Info_selects__2UQme","requiredAsterisk":"Info_requiredAsterisk__23s72"};